import { render, staticRenderFns } from "./LinkElement.vue?vue&type=template&id=006d6b12&"
import script from "./LinkElement.vue?vue&type=script&lang=ts&"
export * from "./LinkElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports